import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from '../../components/bootstrap/Card';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Icon from '../../components/icon/Icon';
import { JobTemplate } from '../JD-template/JobList';
import Button, { ButtonGroup } from '../../components/bootstrap/Button';
import useDarkMode from '../../hooks/useDarkMode';
import ReactQuill from 'react-quill';
import { SpinnerCircular } from 'spinners-react';
import Label from '../../components/bootstrap/forms/Label';
import Select from '../../components/bootstrap/forms/Select';
import usejobRequisition from '../../components/utils/PermissionChecking';
import {
	CandidatesResponse,
	Department,
	InterviewAssignment,
	JobReq,
	MetaData,
	Recruiter,
	RequirementData,
	RoleParameter,
	RoundTypeData,
	User,
} from '../Role_Layout/roleTypes';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import UserStatus from './Interview_Mode';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import classNames from 'classnames';
import useSortableData from '../../hooks/useSortableData';
import PaginationButtons from '../../components/PaginationButton';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../components/bootstrap/Modal';
import Spinner from '../../components/bootstrap/Spinner';
import { centralApi } from '../AxiosInstance/CreateInstance';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {
	CalendarCheck,
	ClipboardList,
	FileText,
	FormInput,
	ListTodo,
	UserCheck,
	UserPlus,
	Users,
	UserSearch,
	UserX,
} from 'lucide-react';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../components/bootstrap/Dropdown';
import SubHeader, { SubHeaderLeft } from '../../layout/SubHeader/SubHeader';
import Textarea from '../../components/bootstrap/forms/Textarea';
import Page from '../../layout/Page/Page';
import InterviewDetailsTable from './InterviewDetailsTable';
import AttachInterviewTab from './Components/AttachInterviewTab';
import JobTemplateTab from './Components/JobTemplateTab';
import AppliedCandidatesStatus from './Components/AppliedCandidatesStatus';
import AppliedCandidates from './Components/AppliedCandidates';
import DeleteConfirmationModal from './Components/Modals/DeleteConfirmationModal';
import RejectCandidateModal from './Components/Modals/RejectCandidateModal';
import ScheduleInterviewModal from './Components/Modals/ScheduleInterviewModal';
import { AxiosError } from 'axios';
import { statusClasses } from '../../constants/statusClasses';
import { TIcons } from '../../type/icons-type';

dayjs.extend(customParseFormat);

interface InfoCardProps {
	icon: TIcons;
	title: string;
	value?: string | number | null;
	iconColor?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({
	icon,
	title,
	value = 'N/A',
	iconColor = '#00BCD4',
}) => {
	return (
		<div className="info-card">
			<div
				className="info-card__icon"
				style={{ backgroundColor: `${iconColor}20` }}>
				<Icon icon={icon} size='2x' style={{ color: iconColor }} />
			</div>

			<div className="info-card__content">
				<div className="info-card__title">{title}</div>
				<div className="info-card__value">{value || 'N/A'}</div>
			</div>
		</div>
	);
};

InfoCard.defaultProps = {
	value: 'N/A',
	iconColor: '#00BCD4',
};

interface IInterviewProp {
	isFluid?: boolean;
}

interface RoundType {
	id: number;
	name: string;
}

const roundtypes: RoundType[] = [
	{ id: 1, name: 'L1' },
	{ id: 2, name: 'L2' },
	// { id: 3, name: 'L3' },
	{ id: 4, name: 'HR' },
];

const scheduleDuration = [
	{ id: 1, name: '30' },
	{ id: 2, name: '45' },
	{ id: 3, name: '60' },
	{ id: 4, name: '90' },
];

const TABS: { [key: string]: { label: string; apiValue: string } } = {
	JOBTEMPLATE: { label: 'Job Template', apiValue: 'new request' },
	ATTACHINTERVIEW: { label: 'Attach Interview', apiValue: 'review' },
	AppliedCandidates: { label: 'Applied Candidates', apiValue: 'applied candidates' },
};

const InterviewPanel: React.FC<IInterviewProp> = ({ isFluid }) => {
	const [jobreq, setJobReq] = useState<JobReq>();
	const [jdTitle, setJdTitle] = useState<JobTemplate>();
	const [users, setUsers] = useState<User[]>([]);
	const [usersAll, setUsersAll] = useState<User[]>([]);
	const [interviews, setInterviews] = useState<InterviewAssignment[]>([]);
	const { id } = useParams();
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(10);
	const [totalItems, setTotalItems] = useState(0);
	const [totalCandi, setTotalCandi] = useState(0);
	const [delModal, setDelModal] = useState(false);
	const [delId, setDelId] = useState('');
	const [resumeModal, setResumeModal] = useState(false);
	const [rejectModal, setRejectModal] = useState(false);
	const [shortModal, setShortModal] = useState(false);
	const [updateItem, setUpdateItem] = useState<InterviewAssignment>();
	const [loading, setLoading] = useState(false);
	const { themeStatus, darkModeStatus } = useDarkMode();
	const navigate = useNavigate();
	const [feedback, setFeedback] = useState('');
	const [candidates, setCandidates] = useState<CandidatesResponse[]>([]);
	const [allCandidate, setAllCandidates] = useState<CandidatesResponse[]>([]);
	const [rejectItem, setRejectItem] = useState<CandidatesResponse | null>(null);
	const [requirement, setRequirement] = useState<RequirementData>();
	const [meta, setMeta] = useState<MetaData>();
	const [recruiter, setRecruiter] = useState<Recruiter>();
	const [roundType, setRoundType] = useState<RoundTypeData[]>([]);
	const [intDetail, setIntDetail] = useState<InterviewAssignment[]>([]);
	const [shortIntItem, setShortItem] = useState<CandidatesResponse>();
	const [feedbackDrop, setFeedbackDrop] = useState<RoleParameter[]>([]);
	const location = useLocation();
	const [activeTab, setActiveTab] = useState<keyof typeof TABS>(
		(location.state?.activeTab as keyof typeof TABS) || "JOBTEMPLATE"
	);
	const [department, setDepartments] = useState<Department[]>([]);
	const [viewResume, setViewResume] = useState<CandidatesResponse>();
	const [candidateRound, setCandidateRound] = useState<InterviewAssignment[]>([]);
	const [scheduledStatuses, setScheduledStatuses] = useState<
		Record<
			string,
			{
				scheduled: boolean;
				interviewId: string;
			}
		>
	>({});
	const [singleCandidate, setSingleCandidate] = useState<any>(null);
	const [refresh, setRefresh] = useState<boolean>(false);
	const [searchVal, setSearchVal] = useState('');
	const [debouncedSearch, setDebouncedSearch] = useState('');
	const [userSearchVal, setUserSearchVal] = useState('');
	const [debouncedUserSearch, setDebouncedUserSearch] = useState('');
	const [isReschedule, setIsReschedule] = useState(false);
	const [selectedInterview, setSelectedInterview] = useState<any>(null);


	const { hasPermission } = usejobRequisition();
	const moduleName = 'Job Requisition';
	const canAttachInterview = hasPermission(moduleName, 'attach interview');
	const canViewAppliedCandidate = hasPermission(moduleName, 'view applied candidate');
	const canScheduledInterview = hasPermission(moduleName, 'schedule interview');
	const canViewResume = hasPermission(moduleName, 'view resume');
	const canDownloadResume = hasPermission(moduleName, 'download resume');

	const fetchInterviewDetail = useCallback(async () => {
		try {
			await centralApi
				.post('jobService/jobRequest/interviewDetails', {
					jobId: id,
				})
				.then((res) => {
					setIntDetail(res.data.data);
				});
		} catch (error) { }
	}, [id]);

	const fetchRound = useCallback(async () => {
		try {
			await centralApi
				.post('jobService/jobRequest/roundType', {
					jobId: id,
				})
				.then((res) => {
					setRoundType(res.data.data);
				});
		} catch (error) {
			// toast.error('Error while fetching RoundTypes', { closeOnClick: true });
		}
	}, [id]);

	useEffect(() => {
		const fetchRequirenments = async () => {
			try {
				await centralApi
					.post('jobService/jobRequest/requirement', {
						jobId: id,
					})
					.then((res) => {
						setRequirement(res.data.data);
					});
			} catch (error) {
				// toast.error('Error while fetching requirement', { closeOnClick: true });
			}
		};

		const fetchMetaData = async () => {
			try {
				await centralApi
					.post('jobService/jobRequest/meta', {
						jobId: id,
					})
					.then((res) => {
						setMeta(res.data.data);
					});
			} catch (error) {
				// toast.error('Error while fetching metadata', { closeOnClick: true });
			}
		};

		const fetchRecruiter = async () => {
			try {
				await centralApi
					.post('jobService/jobRequest/recruiter', {
						jobId: id,
					})
					.then((res) => {
						setRecruiter(res.data.data[0]);
					});
			} catch (error) {
				// toast.error('Error while fetching recruiter', { closeOnClick: true });
			}
		};

		const fetchDepartment = async () => {
			try {
				await centralApi
					.get(`userService/department/list?pageNo=${1}&limit=${100}`)
					.then((res) => {
						setDepartments(res.data.data);
					});
			} catch (error) {
				// toast.error('Error while fetching departments', { closeOnClick: true });
			}
		};

		fetchRequirenments();
		fetchMetaData();
		fetchRecruiter();
		fetchRound();
		fetchInterviewDetail();
		fetchDepartment();
	}, [id, fetchInterviewDetail, fetchRound]);

	const fetchJobReq = useCallback(async () => {
		try {
			setLoading(true);
			let allData: JobReq[] = [];
			const limit = 50;

			const firstRes = await centralApi.get(
				`jobService/jobRequest/list?pageNo=1&limit=${limit}`,
			);
			const firstPageData: JobReq[] = firstRes.data.data;
			const total = firstRes.data.total || firstPageData.length;
			allData = [...allData, ...firstPageData];

			const totalPages = Math.ceil(total / limit);

			const promises = [];
			for (let i = 2; i <= totalPages; i += 1) {
				promises.push(
					centralApi.get(`jobService/jobRequest/list?pageNo=${i}&limit=${limit}`),
				);
			}

			const results = await Promise.all(promises);
			results.forEach((res) => {
				allData = [...allData, ...res.data.data];
			});

			const filterList = allData.find((item: JobReq) => item._id === id);
			setJobReq(filterList);
		} catch (error) {
			// toast.error('Error while fetching Job Requisition', { closeOnClick: true });
		} finally {
			setLoading(false);
		}
	}, [id]);

	const fetchInterview = useCallback(async () => {
		setLoading(true);
		try {
			const allInterviews: InterviewAssignment[] = [];
			const pageNo = 1;
			const limit = 50;

			const firstRes = await centralApi.get(
				`jobService/interviewPanel/list?limit=${limit}&pageNo=${pageNo}`,
			);
			const { data: firstData, total } = firstRes.data;
			if (Array.isArray(firstData)) {
				allInterviews.push(...firstData);
			}

			const totalPages = Math.ceil(total / limit);

			const promises = [];
			for (let i = 2; i <= totalPages; i += 1) {
				promises.push(
					centralApi.get(`jobService/interviewPanel/list?limit=${limit}&pageNo=${i}`),
				);
			}

			const results = await Promise.all(promises);
			results.forEach((res) => {
				if (Array.isArray(res.data.data)) {
					allInterviews.push(...res.data.data);
				}
			});

			const filterList = allInterviews.filter(
				(item: InterviewAssignment) => item.jobRequisitionId === id,
			);

			setInterviews(filterList);
			setTotalItems(filterList.length || 0);
		} catch {
			// toast.error('Error while fetching interviews', { closeOnClick: true });
		} finally {
			setLoading(false);
		}
	}, [id]);

	const fetchCandidates = useCallback(async () => {
		try {
			const res = await centralApi.post(
				`jobService/candidates/byjob?pageNo=${currentPage}&limit=${perPage}&searchVal=${debouncedSearch}`,
				{ jobRequisitionId: id },
			);

			// Handle no data case
			if (
				res.data?.msg === 'Data Not Found' ||
				!res.data?.data
			) {
				setCandidates([]);
				setTotalCandi(0);
				return;
			}

			// Success case
			setCandidates(res.data.data || []);
			setTotalCandi(res.data.total || 0);

		} catch (err: unknown) {
			const axiosError = err as AxiosError<{ msg?: string }>;

			setCandidates([]);
			setTotalCandi(0);

			if (axiosError.response?.data?.msg) {
				toast.dismiss();
				toast.error(axiosError.response.data.msg, {
					closeOnClick: true,
				});
			} else {
				toast.dismiss();
				toast.error('Something went wrong. Please try again.', {
					closeOnClick: true,
				});
			}
		}
	}, [id, perPage, currentPage, debouncedSearch]);


	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedSearch(searchVal);
		}, 500); // API call after 500ms stop typing

		return () => clearTimeout(timer);
	}, [searchVal]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedUserSearch(userSearchVal);
		}, 500); // API call after 500ms stop typing

		return () => clearTimeout(timer);
	}, [userSearchVal]);

	useEffect(() => {
		const fetchStatuses = async () => {
			const statusMap: Record<
				string,
				{
					scheduled: boolean;
					interviewId: string;
				}
			> = {};

			await Promise.all(
				candidates
					.filter((c) => c?.candidate?.id)
					.map(async (candidate) => {
						const res = await centralApi.get(
							`interviewService/interview_service?page=1&limit=100&candidateId=${candidate.candidate.id}`,
						);

						const scheduledInterview = res?.data?.data?.find(
							(interview: any) => interview.status === 'Scheduled',
						);

						statusMap[candidate.candidate.id] = {
							scheduled: !!scheduledInterview,
							interviewId: scheduledInterview?.interviewId || '',
						};
					}),
			);

			setScheduledStatuses(statusMap);
		};

		if (candidates.length > 0) {
			fetchStatuses();
		}
	}, [candidates]);


	useEffect(() => {
		fetchCandidates();
	}, [fetchCandidates, refresh]);

	const fetchAllCandidates = useCallback(async () => {
		let page = 1;
		const limit = 50;
		const allCandidates: any[] = [];

		try {
			while (true) {
				// eslint-disable-next-line no-await-in-loop
				const res = await centralApi.post(
					`jobService/candidates/byjob?pageNo=${page}&limit=${limit}`,
					{ jobRequisitionId: id },
				);

				const { data, total } = res.data;

				if (data?.length) {
					allCandidates.push(...data);

					if (allCandidates.length >= total) break;

					page += 1;
				} else {
					break;
				}
			}

			setAllCandidates(allCandidates);
		} catch (err: unknown) {
			const axiosError = err as AxiosError<{ msg?: string }>;

			if (axiosError.response?.data?.msg) {
				toast.dismiss();
				toast.error(axiosError.response.data.msg, { closeOnClick: true });
			} else {
				toast.dismiss();
				toast.error('Something went wrong. Please try again.', { closeOnClick: true });
			}
		}
	}, [id]);

	useEffect(() => {
		fetchAllCandidates();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				await fetchJobReq();
			} catch (error) {
				// toast.error('Error while fetching Job Requisition', { closeOnClick: true });
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [fetchJobReq]);

	useEffect(() => {
		if (!jobreq?.jdId?.id || !jobreq?.departmentName) return;

		const fetchAllUsers = async (): Promise<User[]> => {
			const allUsers: User[] = [];
			const pageNo = 1;
			const limit = 50;

			let total = 0;
			try {
				const firstRes = await centralApi.get(
					`userService/user/list?pageNo=${pageNo}&limit=${limit}&searchVal=${debouncedUserSearch}`,
				);
				const { data, total: totalUsers } = firstRes.data;
				allUsers.push(...data);
				total = totalUsers;

				const totalPages = Math.ceil(total / limit);

				const promises = [];
				for (let i = 2; i <= totalPages; i += 1) {
					promises.push(
						centralApi.get(`userService/user/list?pageNo=${i}&limit=${limit}&searchVal=${debouncedUserSearch}`),
					);
				}

				const results = await Promise.all(promises);
				results.forEach((res) => {
					allUsers.push(...res.data.data);
				});
			} catch (error) {
				toast.error('failed to fetch user list', { closeOnClick: true });
			}

			// Filter only active users
			return allUsers.filter((user) => user?.status === 'active');
		};

		const fetchRelatedData = async () => {
			setLoading(true);
			try {
				await Promise.all([
					(async () => {
						try {
							const res = await centralApi.get('jobService/jd-template/list');
							const filterList = res.data.data.find(
								(item: JobTemplate) => item._id === jobreq?.jdId?.id,
							);
							setJdTitle(filterList);
						} catch (error) {
							// toast.error('Error while fetching JD Template', { closeOnClick: true });
						}
					})(),
					(async () => {
						try {
							const allFetchedUsers = await fetchAllUsers();
							setUsersAll(allFetchedUsers);
						} catch (error) {
							// toast.error('Error while fetching users', { closeOnClick: true });
						}
					})(),
					fetchInterview(),
				]);
			} catch (error) {
				toast.error('failed to fetch job template', { closeOnClick: true });
			} finally {
				setLoading(false);
			}
		};

		fetchRelatedData();
	}, [jobreq?.jdId?.id, jobreq?.departmentName, fetchInterview, debouncedUserSearch]);

	useEffect(() => {
		if (!jobreq?.departmentName || !usersAll?.length) return;
		setUsers(usersAll);
	}, [jobreq?.departmentName, usersAll]);

	function capitalizeWords(str: string | undefined): string {
		if (!str) return '';
		return str
			.toLowerCase()
			.split(' ')
			.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	}

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			roundTypes: updateItem?.roundType || [],
			interviewerId: updateItem?.interviewers?.map((item) => item.id) || [],
			scheduleTimeFrom: '',
			scheduleTimeTo: '',
			mode: capitalizeWords(updateItem?.mode) || 'Online',
			feedback: updateItem?.evaluationFormTemplateId
				? [updateItem.evaluationFormTemplateId]
				: [],
		},
		validate: (values) => {
			const errors: {
				roundTypes?: string;
				interviewerId?: string;
				scheduleTimeFrom?: string;
				scheduleTimeTo?: string;
				mode?: string;
				feedback?: string;
			} = {};

			if (values.interviewerId.length === 0) {
				errors.interviewerId = 'Please select Interviewer';
			}
			if (!values.scheduleTimeFrom) {
				errors.scheduleTimeFrom = 'Please pick schedule time from';
			}
			if (!values.scheduleTimeTo) {
				errors.scheduleTimeTo = 'Please select interview length';
			}
			if (values.roundTypes?.length === 0) {
				errors.roundTypes = 'Please select Round Type';
			}
			if (feedbackDrop.length === 0 || values.feedback.length === 0) {
				errors.feedback = 'Please select feedback';
			}
			if (filteredUsers?.length === 0) {
				errors.interviewerId =
					values.roundTypes === 'HR'
						? 'No HR interviewers found. Please add an interviewer to the HR department.'
						: `No interviewers available. Please assign a department to this requirement to view available interviewers.`;
			}
			if (
				roundtypes
					.filter((round) => !roundType.some((res) => res.roundType === round.name))
					.map((item) => ({
						value: item.name,
						text: item.name,
					}))?.length === 0 &&
				!updateItem
			) {
				errors.roundTypes = 'All Rounds are assigned to this job requisition';
			}

			return errors;
		},
		onSubmit: async (values) => {
			try {
				setLoading(true);
				if (updateItem) {
					await centralApi.patch('jobService/interviewPanel/update', {
						jobRequisitionId: id,
						interviewerIds: values.interviewerId,
						roundType: values.roundTypes,
						mode: values.mode,
						scheduledTime: values.scheduleTimeFrom,
						interviewLength: values.scheduleTimeTo,
						interviewPanelId: updateItem.id,
						evaluationFormTemplateId: values.feedback[0],
					});
					toast.success('Interview updated successfully', { closeOnClick: true });
					fetchInterviewDetail();
					fetchRound();
				} else {
					await centralApi.post('jobService/interviewPanel/assignInterviewPanel', {
						jobRequisitionId: id,
						interviewerIds: values.interviewerId,
						roundType: values.roundTypes,
						mode: values.mode,
						scheduledTime: values.scheduleTimeFrom,
						interviewLength: values.scheduleTimeTo,
						evaluationFormTemplateId: values.feedback[0],
					});
					toast.success('Interview attached successfully', { closeOnClick: true });
					fetchInterviewDetail();
					fetchRound();
				}
				formik.resetForm();
				setUpdateItem(undefined);
				fetchInterview();
				scrollToBottom();
			} catch (error: any) {
				const backendMsg = error?.response?.data?.msg;
				toast.error(
					backendMsg ||
					`Error while ${updateItem ? 'updating' : 'attaching'} interview`,
					{ closeOnClick: true }
				);
			} finally {
				setLoading(false);
			}
		},
	});
	useEffect(() => {
		if (!updateItem) {
			formik.setFieldValue('interviewerId', []);
			formik.setFieldTouched('interviewerId', false);
			formik.setFieldValue('feedback', []);
			formik.setFieldTouched('feedback', false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.values.roundTypes]);

	useEffect(() => {
		const HR_DEPARTMENT = process.env.REACT_APP_HR_DEPARTMENT;
		const fetchFeedback = async () => {
			const letHr = formik.values.roundTypes === 'HR';
			const deptId = department.find((item) =>
				letHr ? item.name === HR_DEPARTMENT : item.name === meta?.departmentName,
			)?._id;

			if (!deptId) {
				setFeedbackDrop([]);
				formik.setFieldValue('feedback', []);
				return;
			}

			try {
				const response = await centralApi.post('jobService/feedbackFormTemplate/list', {
					departmentId: deptId,
				});

				const { data } = response.data;
				setFeedbackDrop(data);

				const matchingTemplate = data.find(
					(item: InterviewAssignment) => item.id === updateItem?.evaluationFormTemplateId,
				);

				if (updateItem && matchingTemplate) {
					formik.setFieldValue('feedback', [updateItem.evaluationFormTemplateId]);
				} else {
					formik.setFieldValue('feedback', []);
				}
			} catch (error: any) {
				const isNoFeedback =
					error?.response?.status === 404 &&
					error?.response?.data?.msg === 'No feedback templates found for department.';

				const message = isNoFeedback
					? 'Feedback form for this role has not been created. Please contact the admin or create the feedback form first.'
					: 'Error while fetching feedback';

				toast.info(message, {
					closeOnClick: true,
					toastId: 'feedback-fetch-error',
				});

				setFeedbackDrop([]);
				formik.setFieldValue('feedback', []);
			}
		};

		fetchFeedback();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		formik.values.roundTypes,
		department,
		meta?.departmentName,
		updateItem?.evaluationFormTemplateId,
	]);

	const filteredUsers = useMemo(() => {
		const HR_DEPARTMENT = process.env.REACT_APP_HR_DEPARTMENT;
		const isHR = formik.values.roundTypes === 'HR';
		const baseUsers = isHR
			? usersAll.filter((user) => user?.department === HR_DEPARTMENT)
			: users;

		return baseUsers;
	}, [formik.values.roundTypes, users, usersAll]);

	useEffect(() => {
		const selectedInterviewers = formik.values.interviewerId;
		const validInterviewers = filteredUsers.map((user: User) => user.id);
		const invalidSelection = selectedInterviewers.some(
			(interviewId) => !validInterviewers.includes(interviewId),
		);

		if (invalidSelection) {
			formik.setFieldValue('interviewerId', []);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.values.roundTypes, filteredUsers]);

	const handleDelModal = (item: InterviewAssignment): void => {
		setDelModal(true);
		setDelId(item.id);
	};

	useEffect(() => {
		if (updateItem) {
			formik.setValues({
				roundTypes: updateItem.roundType || '',
				interviewerId: Array.isArray(updateItem.interviewers)
					? updateItem.interviewers.map((interviewer) => interviewer.id)
					: [],
				scheduleTimeFrom: updateItem.scheduledTime,
				scheduleTimeTo: updateItem.interviewLength,
				mode: capitalizeWords(updateItem.mode) || 'Online',
				feedback: [],
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updateItem]);

	useEffect(() => {
		if (!rejectModal) {
			setFeedback('');
		}
		if (!shortModal) {
			shortFormik.resetForm();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [rejectModal, shortModal]);

	const handleDelInterview = async (deleteId: string): Promise<void> => {
		try {
			setLoading(true);
			await centralApi.delete('jobService/interviewPanel/delete', {
				data: {
					interviewPanelId: deleteId,
				},
			});
			toast.success('Interview deleted successfully', { closeOnClick: true });
			fetchInterviewDetail();
			fetchRound();
		} catch (error) {
			toast.error('Failed to delete interview', { closeOnClick: true });
		} finally {
			setLoading(false);
			setDelModal(false);
		}
	};

	const scrollToTop = (pixels: number = 0): void => {
		window.scrollTo({
			top: pixels,
			behavior: 'smooth',
		});
	};

	const scrollToBottom = (): void => {
		window.scrollTo({
			top: document.documentElement.scrollHeight,
			behavior: 'smooth',
		});
	};

	const handleUpdateView = async (item: InterviewAssignment): Promise<void> => {
		setActiveTab('ATTACHINTERVIEW');
		setUpdateItem(item);
		scrollToTop(200);
	};

	const { items: sortedItems } = useSortableData(interviews);

	const handleResumeModal = (item: CandidatesResponse) => {
		setResumeModal(!resumeModal);
		setViewResume(item);
	};

	const handleRejectModal = () => {
		setRejectModal(!rejectModal);
	};

	const handleRejectCandidate = async (feedbacktext: string) => {
		if (feedback.length > 500) {
			toast.error('Feedback must be 500 characters or less', { closeOnClick: true });
			return;
		}

		try {
			await centralApi
				.patch('jobService/candidateStatus/update', {
					candidateApplicationId: rejectItem?.id,
					candidateId: rejectItem?.candidate.id,
					jobRequisitionId: jobreq?._id,
					status: 'not_shortlisted',
					feedback: feedbacktext,
				})
				.then((res) => {
					setRejectModal(false);
					fetchCandidates();
					fetchAllCandidates();
					setRejectItem(null);
					toast.success('Candidate rejected successfully', { closeOnClick: true });
				});
		} catch (error) {
			toast.error('Error while Reject Candidate', { closeOnClick: true });
		}
	};

	const handleShortlist = async (candidate: CandidatesResponse) => {
		try {
			await centralApi
				.patch('jobService/candidateStatus/update', {
					candidateApplicationId: candidate.id,
					candidateId: candidate.candidate.id,
					jobRequisitionId: jobreq?._id,
					status: 'shortlisted',
					feedback:
						'Strong problem-solving skills and clear communication. Demo candidate shortlisted',
				})
				.then((res) => {
					setShortModal(false);
					fetchCandidates();
					fetchAllCandidates();
				});
		} catch (error) {
			toast.error('Error while shortlisting candidate', { closeOnClick: true });
		}
	};

	const shortFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			roundTypes: '',
			interviewerId: [],
			scheduleTimeFrom: '',
			scheduledTime: '',
			durationMinutes: '',
			templateId: '',
			interviewType: 'Human',
		},
		validate: (values) => {
			const errors: {
				roundTypes?: string;
				interviewerId?: string;
				scheduleTimeFrom?: string;
				scheduleTimeTo?: string;
				mode?: string;
				feedback?: string;
				interviewPanelId?: string;
				templateId?: string;
			} = {};
			if (values.scheduleTimeFrom.length === 0) {
				errors.scheduleTimeFrom = 'Please pick Schedule date';
			}
			if (values.roundTypes?.length === 0) {
				errors.roundTypes = 'Please select Round Type';
			}
			if (values.roundTypes === "L1" && values.interviewType === "AI") {
				if (values.interviewerId && values.interviewerId.length > 0) {
					errors.interviewerId = "Interviewer must be empty for AI interview";
				}
			}


			return errors;
		},
		onSubmit: async (values, { setSubmitting }) => {

			if (loading) return;

			try {
				setLoading(true);
				setSubmitting(true);

				// =========================
				// RESCHEDULE API
				// =========================

				if (isReschedule && selectedInterview) {
					const currentRound = intDetail.find(
						(item) => item?.roundType === values.roundTypes
					);

					const validInterviewerIds =
						currentRound?.interviewers?.map((i) => i.id) || [];

					const filteredInterviewers =
						(values.interviewerId || []).filter((interviewer) =>
							validInterviewerIds.includes(interviewer)
						);

					const payload = {
						interviewId: selectedInterview.interviewId,
						interviewerIds: filteredInterviewers,
						scheduledDate: values.scheduleTimeFrom,
						scheduledTime: values.scheduledTime,
						mode:
							intDetail.find(
								(item) => item?.roundType === values.roundTypes
							)?.mode || 'online',

						location: 'Board room A',

						durationMinutes:
							Number(values.durationMinutes) || 45,
					};

					await centralApi.patch(
						'/interviewService/interview_service/update',
						payload
					);

					toast.success('Interview Rescheduled Successfully...');

					setShortModal(false);

					fetchCandidates();
					fetchAllCandidates();
					fetchRound();

					return;
				}

				// =========================
				// SCHEDULE API
				// =========================

				let payload;

				if (
					values.roundTypes === 'L1' &&
					values.interviewType === 'AI'
				) {

					payload = {
						candidateId: shortIntItem?.candidate.id,
						jobRequisitionId: shortIntItem?.jobRequisitionId,
						roundType: values.roundTypes,
						interviewType: 'AI_Interview',
						scheduledDate: values.scheduleTimeFrom,
						questionTemplateId: values.templateId,
					};

				} else {

					payload = {
						candidateId: shortIntItem?.candidate.id,
						jobRequisitionId: shortIntItem?.jobRequisitionId,
						roundType: values.roundTypes,
						interviewerIds: values.interviewerId,
						scheduledDate: values.scheduleTimeFrom,

						mode: intDetail.find(
							(item) =>
								item?.roundType === values?.roundTypes
						)?.mode,

						location: 'pune',
					};
				}

				await centralApi.post(
					'interviewService/interview_service/schedule',
					payload
				);

				toast.success('Interview Schedule Successfully...');

				setShortModal(false);

				fetchCandidates();
				fetchAllCandidates();
				fetchRound();

			} catch (error: any) {
				const backendMessage =
					error?.response?.data?.detail ||
					error?.response?.data?.msg ||
					'';

				if (backendMessage) {
					toast.error(backendMessage);

					// Optional: show validation error on field
					shortFormik.setFieldError(
						'scheduleTimeFrom',
						backendMessage
					);

					return;
				}

				toast.error(
					isReschedule
						? 'Error while rescheduling interview'
						: 'Error while scheduling interview'
				);
			} finally {

				setLoading(false);
				setSubmitting(false);
			}
		}
	});

	const handleShortlistModal = async (item: CandidatesResponse) => {
		try {
			const res = await centralApi.get(
				`interviewService/interview_service?candidateId=${item.candidate.id}`
			);

			setCandidateRound(res.data.data);
		} catch (error) {
			toast.error('failed to fetch candidate', { closeOnClick: true });
		}

		setIsReschedule(false);
		setSelectedInterview(null);

		setSingleCandidate(item);
		setShortItem(item);

		// optional but safer
		setCandidateRound([]);

		setShortModal(true);
	};
	const unassignedRounds = roundtypes.filter(
		(round) => !roundType.some((res) => res.roundType === round.name),
	);

	useEffect(() => {
		if (activeTab === 'ATTACHINTERVIEW' && !updateItem && unassignedRounds.length === 0) {
			// toast.info('All Rounds are assigned to this job requisition', {
			// 	closeOnClick: true,
			// });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeTab, roundtypes, roundType, updateItem]);
	useEffect(() => {
		if (activeTab !== 'ATTACHINTERVIEW') {
			formik.resetForm();
			setUpdateItem(undefined);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeTab]);

	const handleUpdateCandidateStatus = (candidateId: string, newStatus: string) => {
		setCandidates((prev) =>
			prev.map((c) =>
				c.candidate.id === candidateId
					? { ...c, status: newStatus }
					: c
			)
		);
	};

	const handleRescheduleModal = async (
		candidate: any,
		interviewData?: any
	) => {

		try {

			let selectedData = interviewData;

			// OPTIONAL API FETCH
			// only if interviewData not passed

			if (!selectedData) {

				const res = await centralApi.get(
					`/interviewService/interview_service/?candidateId=${candidate.candidate.id}&page=1&limit=1`
				);

				selectedData = res?.data?.data?.[0];
			}

			if (!selectedData) {
				toast.error('Interview not found');
				return;
			}

			setSingleCandidate(candidate);

			setSelectedInterview(selectedData);

			setIsReschedule(true);

			setShortModal(true);

		} catch (err) {

			toast.error('Failed to fetch interview details');
		}
	};

	return (
		<>
			<Page container='fluid'>
				<Card stretch='full'>
					<CardHeader borderSize={1}>
						<CardLabel iconColor='info' className='ms-2'>
							<CardTitle>
								<UserSearch className='me-2 text-info' />
								Interview Panel
							</CardTitle>
						</CardLabel>
					</CardHeader>
					<SubHeaderLeft className="mt-3 ms-3">
						<Button
							icon='ArrowBack'
							onClick={() =>
								navigate("/Requirement", {
									state: {
										activeTab: "APPROVED",
									},
								})
							}
							className='btn btn-light-info hrms-gradient-btn '>
							Back to List
						</Button>
					</SubHeaderLeft>
					<CardBody>
						{/* <Card> */}
						<CardHeader borderSize={1} size='sm'>
							<CardLabel iconColor='info' className='ms-2'>
								<CardTitle>
									<ListTodo className='me-2 text-info' />
									Requirement Details
								</CardTitle>
							</CardLabel>
						</CardHeader>
						<CardBody>
							<div className='row g-3'>
								<div className='col-md-4'>
									<InfoCard
										icon='Person'
										title='Role'
										value={requirement?.designation}
									/>
								</div>

								<div className='col-md-4'>
									<InfoCard
										icon='Apartment'
										title='Department'
										value={meta?.departmentName}
									/>
								</div>

								<div className='col-md-4'>
									<InfoCard
										icon='Work'
										title='Job Title'
										value={jdTitle?.title}
									/>
								</div>

								<div className='col-md-4'>
									<InfoCard
										icon='AccountBalanceWallet'
										title='Budget'
										value={capitalizeWords(requirement?.budget)}
									/>
								</div>

								<div className='col-md-4'>
									<InfoCard
										icon='PriorityHigh'
										title='Urgency'
										value={capitalizeWords(requirement?.urgency)}
									/>
								</div>

								<div className='col-md-4'>
									<InfoCard
										icon='Groups'
										title='Resources'
										value={requirement?.noOfResourses}
									/>
								</div>

								<div className='col-md-4'>
									<InfoCard
										icon="PersonAdd"
										title='Created By'
										value={meta?.createdBy?.name}
									/>
								</div>

								<div className='col-md-4'>
									<InfoCard
										icon='ManageAccounts'
										title='Recruiter'
										value={recruiter?.name}
									/>
								</div>

								<div className='col-md-4'>
									<InfoCard
										icon='Description'
										title='JD Attached By'
										value={meta?.jdAttachedBy?.name}
									/>
								</div>
							</div>
						</CardBody>
						{/* </Card> */}
						{/* <Card> */}
						<CardHeader borderSize={1} size='sm'>
							<CardLabel iconColor='info' className='ms-2'>
								<CardTitle>
									{activeTab === 'JOBTEMPLATE' && (
										<>
											<FileText className='me-2 text-info' />
											Job Template
										</>
									)}
									{activeTab === 'ATTACHINTERVIEW' && (
										<>
											<ClipboardList className='me-2 text-info' />
											Assign Interview
										</>
									)}
									{activeTab === 'AppliedCandidates' && (
										<>
											<FormInput className='me-2 text-info' />
											Applied Candidates
										</>
									)}
								</CardTitle>
							</CardLabel>
						</CardHeader>
						<CardBody>
							<div className='row'>
								<div className='col'>
									<ButtonGroup className='d-flex gap-2'>
										{Object.keys(TABS).map((key) => {
											const isAttachInterviewTab =
												key === 'ATTACHINTERVIEW';
											const allRoundsAssigned =
												!updateItem && unassignedRounds.length === 0;

											const { label: originalLabel } = TABS[key];
											let label = originalLabel;
											if (isAttachInterviewTab && allRoundsAssigned) {
												label = 'Attached Interview';
											}
											const isDisabled =
												key === 'AppliedCandidates' &&
												!canViewAppliedCandidate;
											return (
												<Button
													style={{ borderRadius: '0.5rem' }}
													key={key}
													color='dark'
													className={
														activeTab === key
															? 'hrms-gradient-btn'
															: themeStatus
													}
													// onClick={() => setActiveTab(key)}
													onClick={() => {
														if (!isDisabled) setActiveTab(key);
													}}
													isDisable={isDisabled}>
													{label}
												</Button>
											);
										})}
									</ButtonGroup>
								</div>
							</div>
						</CardBody>

						{activeTab === 'JOBTEMPLATE' && (
							<JobTemplateTab
								loading={loading}
								requirement={requirement}
								darkModeStatus={darkModeStatus}
							/>
						)}

						{activeTab === 'ATTACHINTERVIEW' &&
							(updateItem || unassignedRounds.length > 0) && (
								<AttachInterviewTab
									formik={formik}
									roundtypes={roundtypes}
									roundType={roundType}
									intDetail={intDetail}
									filteredUsers={filteredUsers}
									feedbackDrop={feedbackDrop}
									scheduleDuration={scheduleDuration}
									updateItem={updateItem}
									setUpdateItem={setUpdateItem}
									navigate={navigate}
									themeStatus={themeStatus}
								/>
							)}

						{activeTab === 'AppliedCandidates' && (
							<AppliedCandidatesStatus allCandidate={allCandidate} />
						)}
						{/* </Card> */}

						<InterviewDetailsTable
							sortedItems={sortedItems}
							activeTab={activeTab}
							intDetail={intDetail}
							darkModeStatus={darkModeStatus}
							currentPage={currentPage}
							setCurrentPage={setCurrentPage}
							perPage={perPage}
							setPerPage={setPerPage}
							totalItems={totalItems}
							handleUpdateView={handleUpdateView}
							handleDelModal={handleDelModal}
						/>

						{activeTab === 'AppliedCandidates' && (
							<AppliedCandidates
								setRefresh={setRefresh}
								candidates={candidates}
								scheduledStatuses={scheduledStatuses}
								statusClasses={statusClasses}
								canScheduledInterview={canScheduledInterview}
								// candidateRound={candidateRound}
								canViewResume={canViewResume}
								currentPage={currentPage}
								setCurrentPage={setCurrentPage}
								perPage={perPage}
								setPerPage={setPerPage}
								totalCandi={totalCandi}
								handleShortlist={handleShortlist}
								handleShortlistModal={handleShortlistModal}
								handleResumeModal={handleResumeModal}
								handleRejectModal={handleRejectModal}
								setRejectItem={setRejectItem}
								navigate={navigate}
								toast={toast}
								updateCandidateStatus={handleUpdateCandidateStatus}
								jdTitle={jdTitle}
								departmentName={jobreq?.departmentName}
								title={requirement?.designation}
								searchQuery={searchVal}
								setSearchQuery={setSearchVal}
								handleRescheduleModal={handleRescheduleModal}
							/>
						)}
					</CardBody>
				</Card>
			</Page>

			<DeleteConfirmationModal
				isOpen={delModal}
				setIsOpen={setDelModal}
				onDelete={handleDelInterview}
				delId={delId}
				setDelId={setDelId}
				themeStatus={themeStatus}
			/>

			<RejectCandidateModal
				isOpen={rejectModal}
				setIsOpen={setRejectModal}
				rejectItem={rejectItem}
				feedback={feedback}
				setFeedback={setFeedback}
				handleRejectCandidate={handleRejectCandidate}
			/>

			<Modal isOpen={resumeModal} setIsOpen={setResumeModal} size='lg' centered>
				<ModalHeader className='d-flex justify-content-between align-items-center'>
					<ModalTitle id='resume-view' className='mb-0'>
						Candidate Resume
					</ModalTitle>

					<div className='d-flex align-items-center gap-2'>
						<a
							// href={`${centralApi}/public/candidate/view-resume/${viewResume?.id}`}
							href={`${centralApi.defaults.baseURL}public/candidateService/candidate_upload/download-resume/${viewResume?.id}`}
							target='_blank'
							rel='noopener noreferrer'
							// className='btn btn-sm btn-outline-primary'
							className={`btn btn-sm btn-outline-primary ${!canDownloadResume ? 'disabled' : ''}`}
							style={{ fontWeight: '500' }}
							download>
							Download
						</a>

						<Button
							type='button'
							className='btn-close'
							aria-label='Close'
							onClick={() => setResumeModal(false)}
						/>
					</div>
				</ModalHeader>

				<ModalBody style={{ height: '80vh', padding: '0' }}>
					<iframe
						src={`${centralApi.defaults.baseURL}public/candidateService${viewResume?.resumePath}#toolbar=0&navpanes=0`}
						title='Resume Viewer'
						width='100%'
						height='100%'
						style={{ border: 'none' }}
					/>
				</ModalBody>
			</Modal>

			<ScheduleInterviewModal
				singleCandidate={singleCandidate}
				shortModal={shortModal}
				setShortModal={setShortModal}
				shortFormik={shortFormik}
				intDetail={intDetail}
				loading={loading}
				themeStatus={themeStatus}

				isReschedule={isReschedule}
				selectedInterview={selectedInterview}
			/>
		</>
	);

};

InterviewPanel.defaultProps = {
	isFluid: false,
};

export default InterviewPanel;
